<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary.create-codeconfig-button(:to="{name: 'createCodeConfiguration'}") Create Code Config

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Id
        th Type
        th Name
        th Alias
        th
      tr(v-for="cc in codeConfigs")
        td {{ cc.id }}
        td {{ cc.type }}
        td {{ cc.name }}
        td {{ cc.alias }}
        td.actions
          router-link.btn-view(:to="{ name: 'codeConfiguration', params: { id: cc.id } }") View

</template>

<script>
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import { numberFilter } from '@/filters/filters'

export default {
  data: () => ({
    errorMsg: null,
    codeConfigs: []
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return Core.getCodeConfigurations(req)
        .then((resp) => {
          this.codeConfigs = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  filters: {
    number: numberFilter
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/codeconfiguration/CodeConfigurations.vue